import { Component, OnInit, inject, signal } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogClose,
} from '@angular/material/dialog';
import { CaseData } from 'src/app/models/case-data.model';

import { FormBuilder, Validators, FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CustomInputFieldComponent } from '../../components/custom-input-field/custom-input-field.component';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { CustomCheckboxComponent } from '../../components/custom-checkbox/custom-checkbox.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

type PaymentPlanStartDialogData = {
  caseData: CaseData;
  keyId: string;
};

@Component({
  selector: 'app-payment-plan-start-dialog',
  templateUrl: './payment-plan-start-dialog.component.html',
  styleUrls: ['./payment-plan-start-dialog.component.scss'],
  imports: [
    CustomInputFieldComponent,
    MatButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatIcon,
    FormsModule,
    CustomCheckboxComponent,
    MatProgressSpinner,
    MatDialogClose,
    TranslateModule,
  ],
})
export class PaymentPlanStartDialogComponent implements OnInit {
  private dialogRef =
    inject<MatDialogRef<PaymentPlanStartDialogComponent>>(MatDialogRef);
  private fb = inject(FormBuilder);
  private route = inject(ActivatedRoute);
  private data = inject<PaymentPlanStartDialogData>(MAT_DIALOG_DATA);

  readonly agreementForm = this.fb.group({
    pp: this.fb.control(false, {
      validators: Validators.requiredTrue,
      nonNullable: true,
    }),
    aszf: this.fb.control(false, {
      validators: Validators.requiredTrue,
      nonNullable: true,
    }),
  });

  caseData = this.data.caseData;
  keyId = this.data.keyId;

  paymentPlans = new Map();
  selectedPayment = 0;
  readonly loading = signal(false);
  ppStarted = false;

  get selectedPaymentPlans() {
    return this.paymentPlans.get(this.selectedPayment);
  }

  get aszf() {
    return this.agreementForm.controls.aszf;
  }
  get pp() {
    return this.agreementForm.controls.pp;
  }

  async ngOnInit() {
    await this.selectPaymentPlan(this.caseData.payment_plan_options[0]);
  }

  async selectPaymentPlan(count: number) {
    throw new Error(`Unimplemented selectPaymentPlan(${count})`);
  }

  async startPaymentPlan() {
    this.loading.set(true);
    throw new Error('Unimplemented');

    this.dialogRef.afterClosed().subscribe(() => {
      window.location.reload();
    });
    this.loading.set(false);
    this.ppStarted = true;
  }
}
